import { translate } from '@jsverse/transloco';

/**
 * Croatian defaults for the card-confirmation strings. Translations come from the
 * backend (/api/v1/localization) and these keys are new there — until they are added
 * a missing key would render raw, so the default stands in. Keep the keys in sync
 * with what is handed to the BE for localization.
 */
const DEFAULTS: Record<string, string> = {
    // Header pill
    'payment.card_preauth.header.confirm': 'Potvrdi karticu',
    'payment.card_preauth.header.buy_again': 'Aktiviraj pretplatu',
    'payment.card_preauth.header.expires': 'Pretplata ističe',
    'payment.card_preauth.header.tomorrow': 'sutra',
    'payment.card_preauth.header.today': 'danas',
    'payment.card_preauth.header.expired': 'Pretplata nije aktivna',
    // Toast
    'payment.card_preauth.toast.text': 'Promijenili smo način obrade plaćanja. Kako bi se vaša pretplata automatski obnovila, jednom potvrdite karticu.',
    // Toast text once the subscription has expired (AVIION-37482).
    'payment.card_preauth.toast.expired_text': 'Provjeri status svoje pretplate i produlji je ovdje kako bi nastavio/la uživati u omiljenim sadržajima na Nova Play. Čekaju te epizode prije TV emitiranja, a uskoro stižu i nove utakmice hrvatske reprezentacije!',
    // Existing keys reused here, defaults only for the moment before translations load:
    'common.not_now': 'Kasnije',
    'account_notice.button.confirm': 'Potvrdi podatke',
    'payment.card_preauth.toast.expired_title': 'Pretplata se nije automatski obnovila {0}',
    'payment.card_preauth.toast.expired_confirm': 'Aktiviraj pretplatu',
    // Subscriptions page
    'payment.card_preauth.subscription.title': 'Uključite automatsku obnovu',
    'payment.card_preauth.subscription.auto_renew': 'Automatska obnova',
    // Card pre-authorized, not charged yet (eligibility `cardPreregistered`)
    'payment.card_preauth.preregistered.title': 'Kartica je potvrđena',
    'payment.card_preauth.preregistered.text': 'Pretplata se automatski obnavlja. Prva naplata s kartice: {0} · {1}',
    'payment.card_preauth.subscription.reservation': 'Danas vam ništa ne naplaćujemo: radi provjere kartice rezervirat ćemo {0} i rezervaciju odmah poništiti.',
    // Payment return
    'payment.card_preauth.success.title': 'Podaci su spremljeni',
    'payment.card_preauth.success.message': 'Kartica je potvrđena. Pretplata će se ubuduće automatski obnavljati.',
    'payment.card_preauth.failed.title': 'Potvrda kartice nije uspjela',
    'payment.card_preauth.failed.message': 'Ništa nije naplaćeno. Pokušajte ponovno.',
};

/** `translate` with the Croatian default when the backend has no value for the key yet. */
export function cardPreauthText(key: string, params: string[] = []): string {
    const translated = translate(key, Object.fromEntries(params.map((p, i) => [i, p])));
    if (translated && translated !== key) return translated;
    return (DEFAULTS[key] ?? key).replace(/\{(\d+)\}/g, (match, i) => params[+i] ?? match);
}
